import * as React from 'react';
import {editDac} from "../../../Store/Reducers/Dac/actions";
import {connect, ConnectedProps} from "react-redux";
import {CollectionsState} from "../../../Store/Reducers/Collections/types";
import {Drawer} from "antd";
import TextField from "../../Input/TextField/TextField";
import './Clauses.scss';
import {nanoid} from "nanoid";
import { DacCompState } from '../../../views/Dac/Dac';
import User from '../../../utils/User/User';


interface RootState {
    collectionsReducer: CollectionsState,
    dacReducer: {
        clauses: Array<{ _id: string, title: string, describe_clauses: string }>
    }
}

const mapState = (state: RootState) => ({
    Clauses: state.collectionsReducer.Clause,
    dacClauses: state.dacReducer.clauses
});


const mapDispatch = {
    editDac: (name: string, value: any) => editDac(name, value),
};

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props extends PropsFromRedux {
    dacClauses?: Array<{ _id: string, title: string, describe_clauses: string }>;
}

interface State {
    clauses: Array<{ _id: string, title: string, describe_clauses: string }>,
    clauseId: string,
    openDrawer: boolean,
    selectedIds: Array<string>,
    clausesPerso: Array<{ _id: string, title: string, describe_clauses: string }>,
    title: string,
    describe_clauses: string,
    dacState: DacCompState,
    canCreate: boolean
}

class Clauses extends React.Component<Props, State> {
    private readonly ALLOWED_EMAILS = ['benoit.huard@sayse.fr', 'yoann.guez@sayse.fr','simon.canuel@sayse.fr'];
    
    constructor(props: any) {
        super(props);
        this.state = {
            clauses: [],
            openDrawer: false,
            clauseId: '',
            title: '',
            describe_clauses: '',
            selectedIds: [],
            clausesPerso: [],
            dacState: props.dacState,
            canCreate: false
        }
    }

    async componentDidMount() {
        if (this.props.Clauses.length > 0) {
            this.setState(prevState => ({...prevState, clauses: this.props.Clauses}));
        }
        
        // Initialize selectedIds from dacClauses
        if (this.props.dacClauses && this.props.dacClauses.length > 0) {
            const clauseIds = this.props.dacClauses.map(clause => clause._id);
            
            // Separate standard clauses and personal clauses
            const standardClauseIds = this.props.Clauses.map(c => c._id);
            const personalClauses = this.props.dacClauses.filter(c => !standardClauseIds.includes(c._id));
            
            this.setState(prevState => ({
                ...prevState, 
                selectedIds: clauseIds,
                clausesPerso: personalClauses
            }));
        }

        // Add check for user permissions
        try {
            // const userInfo = await User.userInfo();
            // const canCreate = this.ALLOWED_EMAILS.includes(userInfo?.email || '');
            this.setState({ canCreate: true });
        } catch (error) {
            console.error("Error checking user permissions:", error);
            this.setState({ canCreate: false });
        }
    }


    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        // Handle standard clauses collection update
        if (this.state.clauses.length === 0 && prevProps.Clauses !== this.props.Clauses) {
            this.setState(prevState => ({...prevState, clauses: this.props.Clauses}));
        }
        
        // Reset state when dacClauses is cleared
        if (prevProps.dacClauses && prevProps.dacClauses.length > 0 && 
            (!this.props.dacClauses || this.props.dacClauses.length === 0)) {
            this.setState(prevState => ({
                ...prevState,
                selectedIds: [],
                clausesPerso: []
            }));
        }
        // Existing conditions for handling dacClauses updates
        else if (prevProps.dacClauses !== this.props.dacClauses && this.props.dacClauses) {
            const clauseIds = this.props.dacClauses.map(clause => clause._id);
            
            // Separate standard clauses and personal clauses
            const standardClauseIds = this.props.Clauses.map(c => c._id);
            const personalClauses = this.props.dacClauses.filter(c => !standardClauseIds.includes(c._id));
            
            // Only update if we have new personal clauses and they aren't already in state
            if (personalClauses.length > 0 && 
                JSON.stringify(this.state.clausesPerso.map(c => c._id).sort()) !== 
                JSON.stringify(personalClauses.map(c => c._id).sort())) {
                
                this.setState(prevState => ({
                    ...prevState, 
                    selectedIds: clauseIds,
                    clausesPerso: personalClauses
                }));
            } else if (clauseIds.length > 0 && 
                      JSON.stringify(this.state.selectedIds.sort()) !== 
                      JSON.stringify(clauseIds.sort())) {
                
                // If just the selection changed
                this.setState(prevState => ({
                    ...prevState, 
                    selectedIds: clauseIds
                }));
            }
        }
        
        // Update the reducer with selected clauses
        if (prevState.selectedIds !== this.state.selectedIds || 
            prevState.clauses !== this.state.clauses || 
            prevState.clausesPerso !== this.state.clausesPerso) {
            this.addClausesReducer();
        }
    }

    addClausesReducer = () => {
        const {selectedIds, clauses, clausesPerso} = this.state;
        const newClauses = [
            ...clauses.filter(c => selectedIds.includes(c._id)),
            ...clausesPerso.filter(c => selectedIds.includes(c._id))
        ];

        this.props.editDac('clauses', newClauses);
    }

    canCreateClauses = (): boolean => {
        return this.state.canCreate;
    }

    openDrawer = (clauseId?: string) => {
        if (!clauseId && !this.canCreateClauses()) {
            console.log("User doesn't have permission to create clauses");
            return;
        }
        
        this.setState(prevState => ({
            ...prevState, 
            openDrawer: true, 
            clauseId: clauseId ? clauseId : ''
        }));
    }

    closeDrawer = () => {
        this.setState(prevState => ({...prevState, openDrawer: false, clauseId: ''}));

    }

    edit = (name: string, value: string) => {
        if (this.state.clauseId) {
            const { clauses, clausesPerso, clauseId } = this.state;
            
            // Check if it's a standard clause
            const standardClauseIndex = clauses.findIndex(c => c._id === clauseId);
            if (standardClauseIndex >= 0) {
                const newClauses = [...clauses];
                newClauses[standardClauseIndex] = {
                    ...newClauses[standardClauseIndex],
                    [name]: value
                };
                this.setState(prevState => ({...prevState, clauses: newClauses}));
            } else {
                // It's a personal clause
                const personalClauseIndex = clausesPerso.findIndex(c => c._id === clauseId);
                if (personalClauseIndex >= 0) {
                    const newClausesPerso = [...clausesPerso];
                    newClausesPerso[personalClauseIndex] = {
                        ...newClausesPerso[personalClauseIndex],
                        [name]: value
                    };
                    this.setState(prevState => ({...prevState, clausesPerso: newClausesPerso}));
                }
            }
        } else {
            this.setState(state => ({...state, [name]: value}));
        }
    }

    selected = (clauseIds: string) => {
        const {selectedIds} = this.state;
        if (selectedIds.find(i => i === clauseIds)) {
            this.setState(prevState => ({
                ...prevState,
                selectedIds: selectedIds.filter(i => i !== clauseIds)
            }))
        } else {
            this.setState(prevState => ({...prevState, selectedIds: [...selectedIds, clauseIds]}))
        }
    }

    addClauses = () => {
        if (!this.canCreateClauses()) {
            console.error("Unauthorized attempt to create clause");
            return;
        }

        // Check if title and description are provided
        if (!this.state.title || !this.state.title.trim() === '') {
            console.error("Title is required for a clause");
            return;
        }

        // Generate a unique ID for the new clause
        const newClauseId = nanoid();
        
        // Create the new clause object
        const newClause = {
            _id: newClauseId,
            title: this.state.title,
            describe_clauses: this.state.describe_clauses
        };
        
        // Add to clausesPerso array and also select it
        this.setState(prevState => ({
            clausesPerso: [...prevState.clausesPerso, newClause],
            selectedIds: [...prevState.selectedIds, newClauseId],
            title: '',
            describe_clauses: ''
        }), () => {
            // Log success and close drawer
            console.log("New clause added successfully:", newClause);
            this.closeDrawer();
        });
    }

    render() {
        const {clauses, openDrawer, clauseId, clausesPerso, selectedIds} = this.state;
        const canCreate = this.canCreateClauses();
        
        // Get the current clause either from standard clauses or personal clauses
        const standardClause = clauses.find(c => c._id === clauseId);
        const personalClause = clausesPerso.find(c => c._id === clauseId);
        const currentClause = standardClause || personalClause;

        console.log(standardClause, "standardClause")
        console.log(personalClause, "personalClause")
        console.log(currentClause, "currentClause")

        console.log(clauses, "clauses")
        console.log(clausesPerso, "clausesPerso")

        return (
            <div id={'Clauses'}>
                <h2>Clauses</h2>
                <div className={'dac__form list_clauses'}>
                    {clauses.map(clause => (
                        <div key={clause._id} className={'ctn_clause'}>
                            <div className={'ctn-checkbox'}>
                                <input 
                                    onChange={() => this.selected(clause._id)} 
                                    type={'checkbox'}
                                    checked={selectedIds.includes(clause._id)}
                                />
                            </div>
                            <button onClick={() => this.openDrawer(clause._id)}>{clause.title}</button>
                        </div>
                    ))}
                    {clausesPerso.map(clause => (
                        <div key={clause._id} className={'ctn_clause'}>
                            <div className={'ctn-checkbox'}>
                                <input 
                                    onChange={() => this.selected(clause._id)} 
                                    type={'checkbox'}
                                    checked={selectedIds.includes(clause._id)}
                                />
                            </div>
                            <button onClick={() => this.openDrawer(clause._id)}>{clause.title}</button>
                        </div>
                    ))}
                    {canCreate && (
                        <div className={'ctn_clause'}>
                            <div className={'ctn-checkbox'}>
                            </div>
                            <button onClick={() => this.openDrawer()}>+ Ajouter</button>
                        </div>
                    )}
                </div>
                <Drawer
                    title={currentClause ? "Modification de la clause" : "Ajouter une clause"}
                    placement="right"
                    closable={false}
                    onClose={this.closeDrawer}
                    width={'41%'}
                    visible={openDrawer}
                >
                    <>
                        <TextField 
                            ariaLabel={'clauses_title'} 
                            type={'text'} 
                            name={'title'} 
                            label={'Titre'}
                            placeholder={currentClause ? currentClause.title : 'Titre de la clause'}
                            actionReducer={this.edit} 
                            inputType={'input'}
                        />
                        <TextField 
                            ariaLabel={'clauses_describe_clauses'} 
                            type={'text'} 
                            name={'describe_clauses'}
                            label={'Description'}
                            placeholder={currentClause ? currentClause.describe_clauses : 'Description de la clauses'}
                            actionReducer={this.edit} 
                            inputType={'textarea'}
                        />
                        {!currentClause &&
                        <div>
                            <button onClick={this.addClauses}>Ajouter</button>
                            <button onClick={this.closeDrawer}>Annuler</button>
                        </div>
                        }
                    </>
                </Drawer>
            </div>
        )
    }
}

export default connector(Clauses);